import React, { useState } from "react";
import { parseAssessmentMarkdown } from "../utils/assessmentMarkdownParser";
import { SVG_ICONS } from "./TablerIconPicker";
import "../styles/Modal.css";

const AssessmentMarkdownImportModal = ({ onImport, onCancel }) => {
  const [markdown, setMarkdown] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {
    setError("");
    setLoading(true);

    try {
      console.log("🔄 Starting markdown parse...");
      const assessment = parseAssessmentMarkdown(markdown);
      console.log("Parse successful. Assessment:", assessment);
      console.log("  - Name:", assessment?.name);
      console.log("  - Description:", assessment?.description);
      console.log("  - Questions:", assessment?.questions?.length);
      console.log("  - Score Bands:", assessment?.scoreBands?.length);

      if (!assessment) {
        throw new Error("Parser returned undefined");
      }

      onImport(assessment);
    } catch (err) {
      console.error("Parse error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const exampleMarkdown = `DETAILS; AI Readiness Assessment, Evaluate your organization's readiness for AI implementation
Show Results: scoreAndAnswers
Allow user to retake: true
Version: 1.0

Q: How prepared is your organization for AI integration?
O: Not at all prepared == 1
O: Somewhat unprepared == 2
O: Neutral == 3
O: Somewhat prepared == 4
O: Fully prepared == 5

Q: What is your team's technical expertise level?
O: No technical experience == 1
O: Basic understanding == 2
O: Intermediate skills == 3
O: Advanced skills == 4
O: Expert level == 5

Q: How much budget have you allocated for AI initiatives?
O: No budget allocated == 1
O: Minimal budget == 2
O: Moderate budget == 3
O: Significant budget == 4
O: Substantial budget == 5

SCOREBANDS:
BAND: 0,5,Novice,Just starting your AI journey,#FF6B6B
BAND: 6,10,Beginner,Early stages of AI adoption,#FFA94D
BAND: 11,12,Intermediate,Making good progress,#FFD93D
BAND: 13,14,Advanced,Well-established AI practices,#6BCF7F
BAND: 15,15,Expert,Industry-leading AI maturity,#4D96FF

Note: Use "==" (double equals) between option text and score
Each question needs multiple options with unique scores
Score bands define result tiers based on total score`;


  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h2 style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
            {SVG_ICONS["notes"]({ size: 20, color: "#5B9EF0" })}
            Import Assessment from Markdown
          </h2>
          <button className="modal-close" onClick={onCancel} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {SVG_ICONS["x"]({ size: 18, color: "#7A9CC4" })}
          </button>
        </div>

        <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
              Markdown Format:
            </label>
            <textarea
              value={markdown}
              onChange={(e) => setMarkdown(e.target.value)}
              placeholder="Paste your assessment markdown here..."
              style={{
                width: "100%",
                height: "400px",
                padding: "12px",
                fontSize: "13px",
                fontFamily: "monospace",
                border: "1px solid #ddd",
                borderRadius: "6px",
                resize: "vertical"
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: "12px",
              background: "#FFE5E5",
              color: "#C33",
              borderRadius: "6px",
              fontSize: "13px",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              maxHeight: "200px",
              overflowY: "auto"
            }}>
              {error}
            </div>
          )}

          <details style={{ fontSize: "12px", color: "#666" }}>
            <summary style={{ cursor: "pointer", marginBottom: "8px", fontWeight: "600" }}>
              View Example Format
            </summary>
            <pre style={{
              background: "#f5f5f5",
              padding: "12px",
              borderRadius: "4px",
              fontSize: "11px",
              overflowX: "auto",
              maxHeight: "300px",
              overflowY: "auto"
            }}>
              {exampleMarkdown}
            </pre>
          </details>
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="btn-save"
            onClick={handleImport}
            disabled={loading || !markdown.trim()}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
          >
            {loading ? (
              <>
                {SVG_ICONS["hourglass"]({ size: 16, color: "currentColor" })}
                Parsing...
              </>
            ) : (
              <>
                {SVG_ICONS["check"]({ size: 16, color: "currentColor" })}
                Import
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentMarkdownImportModal;
